<script>
import { mapState, mapActions } from 'vuex';
/* components */
// import CustomComponent from '@/components/CustomComponent';
/* tools */
import {} from '@/scripts/utils';
import { oauthOperators } from '@/scripts/constants/map';
import { initGoogleReCaptcha, processGoogleReCaptcha } from '@/scripts/methods';
import { getAuthorizationUrl } from '@/scripts/api/account';

export default {
  name: 'OauthOperators',
  components: {
    // CustomComponent,
  },
  props: {
    action: {
      type: String,
      default: 'Login',
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['user']),
  },
  created() {
    this.oauthOperators = oauthOperators;
  },
  mounted() {
    this.initGoogleReCaptcha().then(() => {
      this.processGoogleReCaptcha();
      this.$emit('ready');
    });
  },
  methods: {
    ...mapActions({}),
    initGoogleReCaptcha,
    processGoogleReCaptcha,
    onRecaptchaVerified(reCaptcha, id, oauthSystem) {
      window.grecaptcha.reset(id);
      // const {} = this;
      const payload = { oauthSystem, reCaptcha };

      getAuthorizationUrl(payload).then(({ authorizationURL, state }) => {
        localStorage.setItem('oauthState', state);

        window.location.href = authorizationURL;

        /* TODO: deprecated */
        /* window.open */
      });
    },
  },
};
</script>

<template>
  <div class="list">
    <div v-for="{ id, name } in oauthOperators" :key="id" class="list__item">
      <button :ref="`recaptcha-${id}`" :class="`link link--${id}`">
        <div class="link__img">
          <img :src="require(`@/assets/png/sign-up/${id}.png`)" />
        </div>
        <div class="link__text">{{ action }} with {{ name }}</div>
      </button>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.list {
  display: flex;
  justify-content: space-between;
  width: 100%;

  &__item {
    width: calc(33.3% - 20px);
    max-width: 170px;
    min-height: 120px;
  }
}

.link {
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: 22px;
  cursor: pointer;
  text-decoration: none;
  outline: none;
  padding: 25px 5px 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  border: 0;
  transition: all 0.2s;

  &__text {
    font-family: Poppins-Regular;
    font-size: 12px;
    line-height: 17px;
    margin-top: 10px;
  }

  &__img {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 40px;

    img {
      height: 40px;
      display: flex;
      width: auto;
    }
  }

  &--twitch {
    color: #ffffff;
    background: #9146ff;

    .link__img {
      img {
        max-height: 19px;
      }
    }
  }

  &--google {
    color: #211d44;
    background: #ffffff;
  }

  &--discord {
    color: #ffffff;
    background: #7289da;
  }

  &:hover {
    opacity: 0.7;
  }
}
/* mobile */
@media (max-width: $mobile) {
  .list {
    flex-wrap: wrap;

    &__item {
      width: 100%;
      max-width: none;
      min-height: auto;

      & + & {
        margin-top: 15px;
      }
    }
  }

  .link {
    border-radius: 12px;
    flex-direction: row;
    justify-content: center;
    padding: 10px;
    min-height: 44px;

    &__text {
      margin-top: 0;
      margin-left: 10px;
    }

    &__img {
      width: auto;
      height: auto;

      img {
        height: auto;
        max-height: 17px;
      }
    }

    &--twitch {
      .link__img {
        img {
          width: 44px;
        }
      }
    }
  }
}
</style>
